'use strict';

var cov_1ri2q1o3fe = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/SecutixObjects/lib/NavigationLinkType.js',
      hash = 'f18e0e9c34849e308c624c00c7b0dde274f1ff4a',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/SecutixObjects/lib/NavigationLinkType.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 27
        },
        end: {
          line: 8,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationLinkType = (cov_1ri2q1o3fe.s[0]++, _propTypes2.default.shape({
  rank: _propTypes2.default.number,
  style: _propTypes2.default.string,
  name: _propTypes2.default.objectOf(_propTypes2.default.string),
  url: _propTypes2.default.objectOf(_propTypes2.default.string)
}));

exports.default = NavigationLinkType;